import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail, MapPin, CheckCircle2 } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import TestimonialsSection from "@/components/TestimonialsSection";

const HERO_IMAGE = "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODA4MzU3NDd8MA&ixlib=rb-4.1.0&q=85";

const SERVICES = [
  { id: "cuisine", title: "Cuisine sur mesure", desc: "Conception, installation et finitions d'exception.", img: "https://images.unsplash.com/photo-1650742030884-87f6ac387bdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwa2l0Y2hlbiUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgwODM1NzM0fDA&ixlib=rb-4.1.0&q=85" },
  { id: "salle-de-bain", title: "Salle de bain", desc: "Création, étanchéité, faïence et plomberie.", img: "https://images.unsplash.com/photo-1580398562556-d33329a0f29b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGVzJTIwZGV0YWlsfGVufDB8fHx8MTc4MDgzNTczNHww&ixlib=rb-4.1.0&q=85" },
  { id: "peinture", title: "Peinture & Enduit", desc: "Finitions lisses, mates et décoratives.", img: "https://images.pexels.com/photos/10533148/pexels-photo-10533148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: "carrelage", title: "Carrelage", desc: "Pose grand format, mosaïques, sols et murs.", img: "https://images.pexels.com/photos/6127332/pexels-photo-6127332.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { id: "renovation", title: "Rénovation complète", desc: "Pilotage A à Z de votre projet de rénovation.", img: "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODA4MzU3NDd8MA&ixlib=rb-4.1.0&q=85" },
  { id: "finitions", title: "Finitions premium", desc: "Détails, plinthes, joints invisibles, qualité atelier.", img: "https://images.pexels.com/photos/19991830/pexels-photo-19991830.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

const GALLERY = [
  "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODA4MzU3NDd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1650742030884-87f6ac387bdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwa2l0Y2hlbiUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgwODM1NzM0fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/19991830/pexels-photo-19991830.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1580398562556-d33329a0f29b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGVzJTIwZGV0YWlsfGVufDB8fHx8MTc4MDgzNTczNHww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/6127332/pexels-photo-6127332.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/10533148/pexels-photo-10533148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export default function Landing() {
  return (
    <div className="bg-[#FAFAFA] text-[#1A1918]">
      <Navbar />

      {/* HERO */}
      <section data-testid="hero-section" className="pt-28 md:pt-36 pb-16 md:pb-24 border-b border-[#E5E3DD]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <div className="reveal text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">
              ◆ Île-de-France &amp; régions voisines
            </div>
            <h1
              data-testid="hero-title"
              className="reveal reveal-delay-1 font-display font-extrabold text-6xl sm:text-7xl lg:text-[120px] leading-[0.9] tracking-tighter mt-6"
            >
              E-PRO<span className="text-[#C86641]">.</span><br />
              Intervention
            </h1>
            <p
              data-testid="hero-slogan"
              className="reveal reveal-delay-2 mt-8 font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight text-[#1A1918]"
            >
              Vos travaux, <span className="italic font-light text-[#5C5A56]">notre </span>
              <span className="text-[#C86641]">savoir-faire.</span>
            </p>
            <p className="reveal reveal-delay-2 mt-6 max-w-xl text-[#5C5A56] text-lg leading-relaxed">
              Micro-entreprise de rénovation premium. De la cuisine sur mesure à la pose de carrelage,
              chaque finition est exécutée avec précision et passion.
            </p>
            <div className="reveal reveal-delay-3 mt-10 flex flex-wrap gap-4">
              <Link
                to="/devis"
                data-testid="hero-cta-devis"
                className="group bg-[#C86641] text-[#FAFAFA] px-8 py-4 font-semibold inline-flex items-center gap-3 hover:bg-[#A65132] transition-colors"
              >
                Demander un devis gratuit
                <ArrowUpRight size={18} className="group-hover:rotate-45 transition-transform" />
              </Link>
              <a
                href="#services"
                data-testid="hero-cta-services"
                className="border border-[#1A1918] text-[#1A1918] px-8 py-4 font-semibold inline-flex items-center gap-3 hover:bg-[#1A1918] hover:text-[#FAFAFA] transition-colors"
              >
                Découvrir nos services
              </a>
            </div>

            <div className="reveal reveal-delay-4 mt-14 flex items-center gap-6">
              <Stat number="5 ★" label="Satisfaction client" />
              <div className="hidden sm:block h-12 w-px bg-[#E5E3DD]" />
              <div className="text-sm text-[#5C5A56] max-w-xs hidden sm:block">
                Plus de 95% de clients satisfaits recommandent E-PRO.Intervention à leurs proches.
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 reveal reveal-delay-2">
            <div className="grid grid-cols-1 gap-3">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1650742030884-87f6ac387bdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwa2l0Y2hlbiUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgwODM1NzM0fDA&ixlib=rb-4.1.0&q=85"
                  alt="Cuisine simple et moderne"
                  className="w-full h-full object-cover"
                  loading="eager"
                  data-testid="hero-image-cuisine"
                />
              </div>
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1580398562556-d33329a0f29b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGVzJTIwZGV0YWlsfGVufDB8fHx8MTc4MDgzNTczNHww&ixlib=rb-4.1.0&q=85"
                  alt="Salle de bain simple et moderne"
                  className="w-full h-full object-cover"
                  loading="eager"
                  data-testid="hero-image-salle-de-bain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MARQUEE */}
      <section className="py-6 border-b border-[#E5E3DD] overflow-hidden bg-[#F3F1ED]">
        <div className="flex whitespace-nowrap animate-marquee">
          {[...Array(2)].flatMap((_, k) =>
            ["Rénovation", "Cuisine", "Salle de bain", "Peinture", "Enduit", "Carrelage", "Finitions"].map((w, i) => (
              <span key={`${k}-${i}`} className="font-display text-3xl md:text-5xl tracking-tighter px-8 text-[#1A1918]">
                {w} <span className="text-[#C86641]">/</span>
              </span>
            ))
          )}
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" data-testid="services-section" className="py-24 md:py-32 border-b border-[#E5E3DD]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
            <div className="md:col-span-4">
              <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">02 — Services</div>
            </div>
            <div className="md:col-span-8">
              <h2 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95]">
                Une expertise sur toutes vos rénovations.
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="group relative overflow-hidden bg-[#F3F1ED]"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-2xl tracking-tight">{s.title}</h3>
                  <p className="mt-2 text-[#5C5A56] text-sm leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* REALISATIONS */}
      <section id="realisations" data-testid="realisations-section" className="py-24 md:py-32 bg-[#F3F1ED] border-b border-[#E5E3DD]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16">
            <div className="md:col-span-4">
              <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">03 — Réalisations</div>
            </div>
            <div className="md:col-span-8">
              <h2 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95]">
                Le détail fait la différence.
              </h2>
              <p className="mt-6 text-[#5C5A56] max-w-2xl">
                Chaque chantier est mené avec rigueur. Voici quelques aperçus de notre travail —
                gros plans et plans moyens pour mettre en lumière la qualité de nos finitions.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {GALLERY.map((src, i) => (
              <div
                key={i}
                className={`overflow-hidden ${i === 0 || i === 4 ? "row-span-2 aspect-[3/4]" : "aspect-square"}`}
                data-testid={`gallery-item-${i}`}
              >
                <img src={src} alt={`Réalisation ${i + 1}`} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY US */}
      <section className="py-24 md:py-32 border-b border-[#E5E3DD]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">04 — Pourquoi nous</div>
            <h2 className="mt-6 font-display text-4xl md:text-5xl tracking-tighter leading-[0.95]">
              Artisan indépendant, qualité d'atelier.
            </h2>
          </div>
          <div className="md:col-span-7 space-y-6">
            {[
              { t: "Devis gratuit & transparent", d: "Une estimation précise, sans frais cachés ni mauvaises surprises." },
              { t: "Interlocuteur unique", d: "Vous échangez directement avec moi, du premier message à la livraison." },
              { t: "Finitions premium", d: "Une exigence permanente du détail, pour un résultat durable." },
              { t: "Île-de-France & au-delà", d: "Interventions dans toute l'IDF et les régions voisines." },
            ].map((it) => (
              <div key={it.t} className="flex gap-4 border-b border-[#E5E3DD] pb-6">
                <CheckCircle2 size={22} className="text-[#C86641] mt-1 shrink-0" />
                <div>
                  <div className="font-semibold text-lg">{it.t}</div>
                  <div className="text-[#5C5A56] mt-1">{it.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TestimonialsSection />

      {/* CONTACT */}
      <section id="contact" data-testid="contact-section" className="py-24 md:py-32 bg-[#1A1918] text-[#FAFAFA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">06 — Contact</div>
            <h2 className="mt-6 font-display text-5xl md:text-7xl tracking-tighter leading-[0.95]">
              Parlons de votre projet.
            </h2>
            <p className="mt-6 text-[#A8A7A3] max-w-xl text-lg">
              Une idée, un chantier, un doute ? Contactez-moi par téléphone, par email,
              ou créez un compte pour démarrer une conversation directe.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/devis" data-testid="contact-cta-devis" className="bg-[#C86641] text-[#FAFAFA] px-8 py-4 font-semibold hover:bg-[#A65132] transition-colors">
                Demander un devis
              </Link>
              <Link to="/inscription" data-testid="contact-cta-chat" className="border border-[#FAFAFA]/30 text-[#FAFAFA] px-8 py-4 font-semibold hover:bg-[#FAFAFA] hover:text-[#1A1918] transition-colors">
                Discuter en direct
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5 space-y-8">
            <ContactItem icon={<Phone size={22} />} label="Téléphone" value="06.60.41.30.73" href="tel:0660413073" testId="contact-phone" />
            <ContactItem icon={<Mail size={22} />} label="Email" value="valdoise-95@hotmail.com" href="mailto:valdoise-95@hotmail.com" testId="contact-email" />
            <ContactItem icon={<MapPin size={22} />} label="Zone d'intervention" value="Île-de-France & régions voisines" testId="contact-area" />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-display text-2xl md:text-3xl font-extrabold tracking-tighter">{number}</div>
      <div className="text-[11px] tracking-[0.15em] uppercase text-[#5C5A56] mt-1">{label}</div>
    </div>
  );
}

function ContactItem({ icon, label, value, href, testId }) {
  const inner = (
    <div className="flex gap-5 items-start border-b border-white/10 pb-6">
      <div className="text-[#C86641]">{icon}</div>
      <div>
        <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-[#A8A7A3]">{label}</div>
        <div className="mt-2 text-xl font-display tracking-tight">{value}</div>
      </div>
    </div>
  );
  return href ? <a href={href} data-testid={testId}>{inner}</a> : <div data-testid={testId}>{inner}</div>;
}
